export const styles = {
  boxContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 7.5,
    marginBottom: 4,
    marginTop: 5,
    paddingInline: { xs: 0, sm: 7.5 },
    minWidth: {
      xs: '80vw', sm: '270px', md: '350px', lg: '400px',
    },
  },
  loanPayoutContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
  },
  loanPayoutButton: {
    marginBottom: 2, width: '100%',
  },
};

export default styles;
